import { AlertSerie } from "../types/alertSerie";
import { COLORS } from "./colors";

export enum AlertStatus {
  NEW = "new",
  IGNORED = "ignored",
  INPROGRESS = "inprogress",
  TOADJUST = "toadjust",
  RESOLVED = "resolved",
}

export const AlertStatusLabel: Record<AlertStatus, string> = {
  [AlertStatus.NEW]: "Nouvelles",
  [AlertStatus.IGNORED]: "Non traitées",
  [AlertStatus.INPROGRESS]: "En cours",
  [AlertStatus.TOADJUST]: "À ajuster",
  [AlertStatus.RESOLVED]: "Résolues",
};

export enum AlertNavigationType {
  TOPROCESS = "to_process",
  INPROGRESS = "in_progress",
  RESOLVED = "resolved",
}

export const AlertStatusList: AlertStatus[] = [
  AlertStatus.NEW,
  AlertStatus.IGNORED,
  AlertStatus.INPROGRESS,
  AlertStatus.TOADJUST,
  AlertStatus.RESOLVED,
];

export const AlertNavigationTypeList: AlertNavigationType[] = [
  AlertNavigationType.TOPROCESS,
  AlertNavigationType.INPROGRESS,
  AlertNavigationType.RESOLVED,
];

export const AlertNavigationLabel: Record<AlertNavigationType, string> = {
  [AlertNavigationType.TOPROCESS]: "À traiter",
  [AlertNavigationType.INPROGRESS]: "En cours",
  [AlertNavigationType.RESOLVED]: "Résolues",
};

export const getStatusStyles = (status: AlertStatus) => {
  switch (status) {
    case AlertStatus.RESOLVED:
      return {
        background: COLORS.bg_green,
        color: COLORS.green,
        title: "Résolue",
        icon: "circle-check-fill",
        status: "success" as const,
      };
    case AlertStatus.NEW:
      return {
        background: "#F5FAFF",
        color: "#173EB4",
        title: "Nouvelle",
        icon: "circle-warning-fill",
        status: "info" as const,
      };
    case AlertStatus.IGNORED:
      return {
        background: "#F5FAFF",
        color: COLORS.red,
        title: "Non traitée",
        icon: "circle-cross-fill",
        status: "error" as const,
      };
    case AlertStatus.INPROGRESS:
      return {
        background: "#F5FAFF",
        color: "#173EB4",
        title: "En cours",
        icon: "loading",
        status: "info" as const,
      };
    case AlertStatus.TOADJUST:
      return {
        background: "#F5FAFF",
        color: "#CC4010",
        title: "À ajuster",
        icon: "alert-triangle",
        status: "warning" as const,
      };
  }
};

export const getNavigationStatus = (
  status: AlertStatus
): AlertNavigationType => {
  switch (status) {
    case AlertStatus.RESOLVED:
      return AlertNavigationType.RESOLVED;
    case AlertStatus.NEW:
      return AlertNavigationType.TOPROCESS;
    case AlertStatus.TOADJUST:
      return AlertNavigationType.INPROGRESS;
    case AlertStatus.IGNORED:
      return AlertNavigationType.TOPROCESS;
    case AlertStatus.INPROGRESS:
      return AlertNavigationType.INPROGRESS;
  }
};

export const getNavigationStyles = (status: AlertNavigationType) => {
  switch (status) {
    case AlertNavigationType.RESOLVED:
      return {
        color: COLORS.green,
        icon: "circle-check-fill",
      };
    case AlertNavigationType.TOPROCESS:
      return {
        color: "#173EB4",
        icon: "circle-warning-fill",
      };
    case AlertNavigationType.INPROGRESS:
      return {
        color: "#173EB4",
        icon: "loading",
      };
  }
};

export const formatDateTimeToFr = (date?: string, monthToSubstract: number = 0) => {
  if(date === undefined) return "";
  const alertDate = new Date(date);
  alertDate.setMonth(alertDate.getMonth() - monthToSubstract);
  const formattedDate = alertDate.toLocaleDateString("fr-FR", {
    month: "long",
    year: "numeric"
  });
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

export const formatDateTimeToDate = (date?: string) => {
  if (date === undefined) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getLastAlertDetail = (alertSerie: AlertSerie) => {
  if (!alertSerie.alertDetails || alertSerie.alertDetails.length === 0) return undefined;
  // Optimization: Use reduce instead of sort to find the latest date (O(n) vs O(n log n))
  return alertSerie.alertDetails.reduce((latest, current) => {
    return (latest.date > current.date) ? latest : current;
  });
};